import i18next from "i18next"
import _ from "lodash"
import { ReactNode, useState, forwardRef, useImperativeHandle } from "react"
import { useTranslation } from "react-i18next"

interface ButtonSpinProps {
    onClick?: () => void
    type?: "button" | "submit"
    icon?: ReactNode
    classBtn?: string
    title: string
    isDisabled?: boolean
}

export interface ButtonSpinHandle {
    toggleSpin: (arg0?: boolean) => void
}

const ButtonSpin = forwardRef<ButtonSpinHandle, ButtonSpinProps>(function ButtonSpin({
    onClick,
    type = "button",
    icon,
    classBtn = "flex w-full justify-center items-center rounded bg-primary p-1.5 px-3 text-white hover:bg-opacity-90",
    title = i18next.t("modal.submit"),
    isDisabled = false
}, ref) {
    const [isSpin, setSpin] = useState(false)

    const onSubmit = () => {
        if (!isSpin) {
            setSpin(true)
            onClick && onClick()
        }
    }

    useImperativeHandle(ref, () => ({
        toggleSpin: (flag) => setSpin(_.isBoolean(flag) ? flag : !isSpin)
    }), [isSpin])

    return (
        <button
            type={type}
            className={classBtn}
            onClick={onSubmit}
            disabled={isDisabled}
        >
            { isSpin ? <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg> : (icon && icon) }
            { title }
        </button>
    )
})

export default ButtonSpin
